/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Actions/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import PreviewSample from './PreviewSample/index'
import PrintLetter from './PrintLetter/index'
import React from 'react'
import SaveAsDraftAction from './SaveAsDraftAction/index'
import SaveAsPdf from './SaveAsPdf/index'
import SendDocument from './SendDocument/index'
import Signature from './Signature/index'
import Upload from './Upload/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Actions({
  children,
  viewPath = "/DesignSystem/PreviewDocument/Content/Content/HtmlFile/Content/Content/Content/Actions"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Actions.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Actions.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mt-1-AjnkD': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<SaveAsDraftAction
  viewPath={`${viewPath}/SaveAsDraftAction`}
/>
<Upload
  viewPath={`${viewPath}/Upload`}
/>
<SaveAsPdf
  viewPath={`${viewPath}/SaveAsPdf`}
/>
<PrintLetter
  viewPath={`${viewPath}/PrintLetter`}
/>
<SendDocument
  viewPath={`${viewPath}/SendDocument`}
/>
<PreviewSample
  viewPath={`${viewPath}/PreviewSample`}
/>
<Signature
  viewPath={`${viewPath}/Signature`}
/>
</div>
</div>
{children}
</React.Fragment>)
}